module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-bw.8c1dce47.png";